<shell-leal-grid
  *ngIf="showLoginForm"
  [style]="{ display: 'grid', height: '100vh', padding: '0' }"
>
  <shell-leal-row class="form-container" align-items="center" justify="center">
    <shell-leal-col col="12" col-xs="8" col-md="6" col-lg="4">
      <shell-leal-box mb="64" [customStyles]="{ 'text-align': 'center' }">
        <img
          src="/assets/images/logoLeal.svg"
          alt=""
          width="128px"
          style="margin: auto"
        />
      </shell-leal-box>
      <div>
        <div>
          <shell-leal-text
            size="large-3xl"
            weight="f-700"
            color="gray-10"
            font="Montserrat"
          >
            Inicia sesión
          </shell-leal-text>
          <shell-leal-box mt="40" pr="0" pl="0" unit="px">
            <shell-leal-text size="x-small" weight="f-500" color="gray-8">
              Ingresa tu usuario
            </shell-leal-text>
            <shell-leal-box mt="8" mr="0" mb="8" ml="0" unit="px">
              <shell-leal-input
                category="text"
                placeholder="Nombre de usuario"
                background="white"
                placeholder-color="gray"
                size="base"
                icon-position="left"
                required="true"
                icon="user-circle"
                (changeInput)="onchangeNameField($event)"
                (keyup.enter)="login()"
                [customId]="'leal-input-login-name'"
              />
            </shell-leal-box>
          </shell-leal-box>
          <shell-leal-box mt="32" pr="0" pl="0" unit="px">
            <shell-leal-text size="x-small" weight="f-500" color="gray-8">
              Ingresa tu contraseña
            </shell-leal-text>
            <shell-leal-box mt="8" mr="0" mb="8" ml="0" unit="px">
              <shell-leal-input
                category="password"
                placeholder="Contraseña"
                background="white"
                placeholder-color="gray"
                size="base"
                icon-position="left"
                required="true"
                icon="key"
                (changeInput)="onchangePasswordField($event)"
                [customId]="'leal-input-login-pass'"
                (keyup.enter)="login()"
              >
              </shell-leal-input>
            </shell-leal-box>
          </shell-leal-box>
          <shell-leal-box mt="40" pr="0" pl="0" unit="px">
            <shell-leal-button
              [customStyles]="{
                  width: '100%',
                  display: 'flex',
                  'align-items': 'center',
                  'justify-content': 'center',
                }"
              text="Iniciar sesión"
              (clickButton)="login()"
              [disabled]="disabledButton"
              [customId]="'leal-input-login-button'"
            />
          </shell-leal-box>
        </div>
      </div>
      <shell-leal-box mt="40" unit="px">
        <shell-leal-text [align]="'center'" weight="f-600">
          <a class="text-link" [routerLink]="['/login/forgot-password']">
            Recuperar contraseña
          </a>
        </shell-leal-text>
      </shell-leal-box>
    </shell-leal-col>
  </shell-leal-row>
</shell-leal-grid>
